import { AdminPermissions, type AdminRole } from '@/types/admin';
import {
  LayoutDashboard,
  ShoppingBag,
  Utensils,
  Users,
  Film,
  Settings,
  Video,
  Music,
  UserCog,
  Building2,
  FileVideo,
} from 'lucide-react';

export const navigationItems = [
  { name: 'Órdenes', href: '/admin/orders', icon: ShoppingBag, staffVisible: true },
  { name: 'Dashboard', href: '/admin/dashboard', icon: LayoutDashboard },
  { name: 'Menú', href: '/admin/items', icon: Utensils },
  { name: 'Multimedia', href: '/admin/ambient-photos', icon: Film },
  { name: 'Videos', href: '/admin/video-settings', icon: Video },
  { name: 'Videos Genéricos', href: '/admin/generic-videos', icon: FileVideo },
  { name: 'Clientes', href: '/admin/clients', icon: Users },
  { name: 'Configuración', href: '/admin/settings', icon: Settings },
];

/** El personal solo ve Órdenes; propietario y gerente, todo (spec 012) */
export function navigationItemsFor(role: AdminRole | undefined | null) {
  if (role && AdminPermissions.canManageItems(role)) return navigationItems;
  return navigationItems.filter((item) => 'staffVisible' in item && item.staffVisible);
}

export const superadminNavigationItems = [
  { name: 'Usuarios', href: '/superadmin/users', icon: UserCog },
  { name: 'Restaurantes', href: '/superadmin/restaurants', icon: Building2 },
  { name: 'Audio Catalog', href: '/superadmin/audio-catalog', icon: Music },
];
